import styled from '@emotion/styled';
import { SidePanel, SidePanelProps } from '@workday/canvas-kit-preview-react/side-panel';
import { WcpStyles } from '@workday/wcp-tokens';
import React from 'react';

const StyledSidePanel = styled(SidePanel)({
  backgroundColor: WcpStyles.color.bg.default,
});

export const ThemedSidePanel: React.FC<SidePanelProps> = (props) => {
  return <StyledSidePanel {...props} />;
};
